import * as React from 'react';

import { WorkRequestJobHazardAssessmentStatus } from '@acceligentllc/shared/enums/workRequestJobHazardAssessmentStatus';

import { SegmentLabel } from '@acceligentllc/storybook';

import { previewSectionClass, previewSectionClassRow } from '../../helpers';

type Props = {
	status: Nullable<WorkRequestJobHazardAssessmentStatus>;
};

const JobHazardAssessmentStatusSection: React.FC<Props> = ({ status }) => {
	const statusValue = React.useMemo(() => {
		if (!status) {
			return 'Not Started';
		}

		switch (status) {
			case (WorkRequestJobHazardAssessmentStatus.COMPLETE): {
				return 'Complete';
			}

			case (WorkRequestJobHazardAssessmentStatus.IN_PROGRESS): {
				return 'In Progress';
			}

			case (WorkRequestJobHazardAssessmentStatus.NOT_STARTED): {
				return 'Not Started';
			}

		}
	}, [status]);
	return (
		<div className={previewSectionClass}>
			<SegmentLabel
				label="Status"
				tooltip="The current progress state of this job record, indicating whether the job is pending, actively in progress, or completed."
			/>
			<div className={previewSectionClassRow}>
				<b>{statusValue}</b>
			</div>
		</div>
	);
};

export default React.memo(JobHazardAssessmentStatusSection);
